import { PresenterFactory } from './PresenterFactory';

class AppContext {
    presenters!: PresenterFactory;
}

export default new AppContext();
